'use client';

import { Button } from '@/components/ui/button';
import { Moon, Sun } from 'lucide-react';
import { useDocsTheme } from './docs-theme-provider';

export const DarkModeButton = () => {
  const { toggle } = useDocsTheme();
  return (
    <Button size="icon" variant="ghost" className="w-6 h-6 [&_svg]:size-4 hover:text-inherit" onClick={toggle}>
      <span className="docs-mode-icon-light"><Moon size={16} className="text-current" /></span>
      <span className="docs-mode-icon-dark"><Sun size={16} className="text-current" /></span>
    </Button>
  );
};
